<div class="mb-4">
    <app-widget-add-activity-control [addressId]="model.id"/>
</div>